import { Outlet } from "react-router-dom"
import { useWhitelabel } from "../../context/whitelabel.context"
import LoadingMain from "../../components/Loadings/LoadingMain"

export const SignedOutPages = () => {
        const {loadedWhitelabel} = useWhitelabel()

    
    return (
        <>
               {!loadedWhitelabel ? 
                <div style={{display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh', backgroundColor: '#000', alignItems: 'center', justifyContent: 'center'}}>
                    <LoadingMain/>
                </div> 
                : 
                <Outlet/>
               } 
        </>
    )
}

